import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";

const TestimonialsPage = () => {
  const { t, i18n } = useTranslation();
  const lang = i18n.language;

  const stats = t("hero.stats", { returnObjects: true }) as { value: string; label: string }[];

  useEffect(() => {
    const existingScript = document.querySelector('script[src="https://reputationhub.site/reputation/assets/review-widget.js"]');
    if (!existingScript) {
      const script = document.createElement("script");
      script.src = "https://reputationhub.site/reputation/assets/review-widget.js";
      script.type = "text/javascript";
      script.async = true;
      document.body.appendChild(script);
    }
  }, []);

  return (
    <>
      <Navbar />
      <main>
        <section className="relative pt-32 pb-16 bg-brand-dark overflow-hidden">
          <div className="absolute inset-0 opacity-20">
            <img src="https://readdy.ai/api/search-image?query=happy%20satisfied%20customers%20clean%20home%20testimonials%20reviews%20five%20stars%20professional%20service%20Florida&width=1920&height=500&seq=test1&orientation=landscape" alt="" className="w-full h-full object-cover object-top" />
          </div>
          <div className="relative max-w-7xl mx-auto px-4 md:px-6 text-center">
            <div className="flex items-center justify-center gap-2 text-white/50 text-sm font-body mb-4">
              <Link to="/" className="hover:text-white transition-colors cursor-pointer">Home</Link>
              <i className="ri-arrow-right-s-line"></i>
              <span className="text-white">{lang === "en" ? "Testimonials" : "Testimonios"}</span>
            </div>
            <h1 className="font-heading font-black text-white text-4xl md:text-6xl mb-4">{t("hero.title")}</h1>
            <p className="font-body text-white/60 text-base md:text-lg max-w-xl mx-auto mb-10">{t("hero.subtitle")}</p>
            <div className="flex flex-wrap justify-center gap-4">
              {stats.map((s, i) => (
                <div key={i} className="bg-white/10 border border-white/20 rounded-2xl px-6 py-4 text-center min-w-[120px]">
                  <p className="font-heading font-black text-brand-green text-2xl">{s.value}</p>
                  <p className="font-body text-white/60 text-xs mt-1">{s.label}</p>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* ReputationHub Reviews Widget - Main Section */}
        <section className="py-16 bg-white">
          <div className="max-w-7xl mx-auto px-4 md:px-6">
            <div className="text-center mb-10">
              <span className="inline-block text-brand-green font-body text-sm font-semibold tracking-widest uppercase mb-2">
                {lang === "en" ? "Testimonials" : "Testimonios"}
              </span>
              <h2 className="font-heading font-black text-brand-dark text-3xl md:text-4xl mb-2">
                {lang === "en" ? "What Our Clients Say" : "Lo Que Dicen Nuestros Clientes"}
              </h2>
              <p className="font-body text-gray-500 text-base max-w-xl mx-auto">
                {lang === "en" ? "Real reviews from real customers — verified on Google." : "Reseñas reales de clientes reales — verificadas en Google."}
              </p>
            </div>
            <div
              className="w-full overflow-hidden rounded-2xl"
              style={{ minHeight: "600px" }}
            >
              <iframe
                className="lc_reviews_widget"
                src="https://reputationhub.site/reputation/widgets/review_widget/Lcd1qbYzaBmMehdAkYeP"
                frameBorder={0}
                scrolling="no"
                style={{ minWidth: "100%", width: "100%", minHeight: "600px", height: "600px", border: "none", display: "block" }}
                title="Customer Reviews"
              />
            </div>
          </div>
        </section>

        <section className="py-14 bg-brand-beige">
          <div className="max-w-2xl mx-auto px-4 text-center">
            <h2 className="font-heading font-bold text-2xl md:text-3xl text-brand-dark mb-3">{lang === "en" ? "Ready to become our next happy client?" : "¿Listo para ser nuestro próximo cliente feliz?"}</h2>
            <p className="font-body text-gray-500 text-base mb-6">{lang === "en" ? "Get your free quote today!" : "¡Obtén tu cotización gratis hoy!"}</p>
            <a href="https://wa.me/15612626118" target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-2 bg-brand-green hover:bg-brand-green-dark text-white px-7 py-3.5 rounded-full font-heading font-semibold text-sm transition-all cursor-pointer whitespace-nowrap">
              <i className="ri-whatsapp-line text-lg"></i>{lang === "en" ? "Request a Free Quote" : "Solicitar Cotización Gratis"}
            </a>
          </div>
        </section>
      </main>
      <Footer />
    </>
  );
};

export default TestimonialsPage;
